var _a, _b, _c, _d;
import { __assign, __rest } from "tslib";
import React from 'react';
/* Icon declaration and export */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
library.add(fal, fas, far, fad);
var fontAwesomeLibrary = library;
export var falLibrary = Object.keys((_a = fontAwesomeLibrary) === null || _a === void 0 ? void 0 : _a.definitions.fal);
export var fasLibrary = Object.keys((_b = fontAwesomeLibrary) === null || _b === void 0 ? void 0 : _b.definitions.fas);
export var farLibrary = Object.keys((_c = fontAwesomeLibrary) === null || _c === void 0 ? void 0 : _c.definitions.far);
export var fadLibrary = Object.keys((_d = fontAwesomeLibrary) === null || _d === void 0 ? void 0 : _d.definitions.fad);
export var Icon = function (_a) {
    var icon = _a.icon, size = _a.size, lib = _a.lib, props = __rest(_a, ["icon", "size", "lib"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FontAwesomeIcon, __assign({ icon: [lib, icon], size: size }, props))));
};
export default Icon;
//# sourceMappingURL=Icon.js.map